// extracted by mini-css-extract-plugin
export default {"theme_context":"f5f3f8"};